(function () {
  var mega = document.querySelector('[data-zl-mega]');
  if (!mega) return;

  var desktop = window.matchMedia('(min-width: 1025px)');
  var catLinks = mega.querySelectorAll('[data-zl-mega-cat-btn]');
  var panels = mega.querySelectorAll('[data-zl-mega-panel]');

  function showCategory(id) {
    catLinks.forEach(function (el) {
      el.classList.toggle('is-active', el.dataset.zlMegaCatBtn === id);
    });
    panels.forEach(function (panel) {
      panel.classList.toggle('is-active', panel.dataset.zlMegaPanel === id);
    });
  }

  // Hover (or tab to) a category to preview its products. Click the name to go to the collection.
  // On touch screens there is no hover, so the first tap shows the products and the second tap opens the collection.
  catLinks.forEach(function (el) {
    var id = el.dataset.zlMegaCatBtn;
    var wasActive = true;
    el.addEventListener('pointerdown', function (e) {
      wasActive = e.pointerType === 'mouse' || el.classList.contains('is-active');
    });
    el.addEventListener('mouseenter', function () { showCategory(id); });
    el.addEventListener('focus', function () { showCategory(id); });
    el.addEventListener('click', function (e) {
      if (el.tagName !== 'A' || !wasActive) {
        e.preventDefault();
        showCategory(id);
      }
      wasActive = true;
    });
  });

  function findShopTrigger() {
    var summaries = document.querySelectorAll('header.header summary');
    for (var i = 0; i < summaries.length; i++) {
      var text = summaries[i].textContent.trim().toLowerCase();
      if (text.indexOf('shop') === 0) return summaries[i];
    }
    return null;
  }

  var trigger = findShopTrigger();
  if (!trigger) return;

  var details = trigger.closest('details');
  var header = document.querySelector('header.header');
  var isOpen = false;

  trigger.setAttribute('aria-controls', mega.id);
  trigger.setAttribute('aria-expanded', 'false');

  // the theme's own Shop dropdown stays hidden on desktop, the mega menu replaces it
  function syncNative() {
    if (details) details.classList.toggle('zl-native-dropdown--hidden', desktop.matches);
  }

  function place() {
    if (header) mega.style.top = Math.max(0, header.getBoundingClientRect().bottom) + 'px';
  }

  function openMega() {
    if (!desktop.matches) return;
    place();
    if (details) {
      details.removeAttribute('open');
      details.classList.add('zl-mega-trigger--open');
    }
    mega.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    isOpen = true;
  }

  function closeMega(refocus) {
    if (!isOpen) return;
    mega.classList.remove('is-open');
    if (details) details.classList.remove('zl-mega-trigger--open');
    trigger.setAttribute('aria-expanded', 'false');
    isOpen = false;
    if (refocus) trigger.focus();
  }

  // click Shop or its arrow to open, click again to close
  trigger.addEventListener('click', function (e) {
    if (!desktop.matches) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (isOpen) closeMega(); else openMega();
  }, true);

  // click anywhere outside the menu to close it
  document.addEventListener('click', function (e) {
    if (!isOpen) return;
    if (mega.contains(e.target) || trigger.contains(e.target)) return;
    closeMega();
  });

  // click a link inside the menu: it closes as you head off
  mega.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (link && !e.defaultPrevented) closeMega();
  });

  document.addEventListener('keydown', function (e) {
    if (isOpen && e.key === 'Escape') closeMega(true);
  });

  window.addEventListener('scroll', function () { if (isOpen) place(); }, { passive: true });
  window.addEventListener('resize', function () { if (isOpen) place(); });

  function onBreakpoint() {
    syncNative();
    if (!desktop.matches) closeMega();
  }
  if (desktop.addEventListener) desktop.addEventListener('change', onBreakpoint);
  else desktop.addListener(onBreakpoint);
  syncNative();
})();
